import Swiper from "swiper";
import {
  bannerConfig,
  getImagePath,
  getBackgroundImagePath,
} from "@/config/bannerConfig.js";
import store from "@/store/index.js";

export const bannerMixin = {
  data() {
    return {
      swiperOption: {
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
        effect: "slide",
        sliderPerView: 6,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
          dynamicBullets: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          hideOnClick: true,
        },
      },
      currentHost: "",
      brandSubdomain: "",
      swiperImages: [],
    };
  },

  computed: {
    swiper() {
      return this.$refs.bannerSwiper?.$swiper;
    },

    // 获取当前品牌的所有轮播图配置
    currentBannerSlides() {
      const slides = [];

      // 添加通用产品轮播图
      bannerConfig.common.forEach((slide) => {
        if (slide.showCondition(this.currentHost, this.brandSubdomain)) {
          slides.push({
            ...slide,
            id: `common-${slides.length}`,
          });
        }
      });

      // 添加品牌特定轮播图
      const brandSlides = bannerConfig.brands[this.currentHost] || [];
      brandSlides.forEach((slide, index) => {
        slides.push({
          ...slide,
          id: `brand-${this.currentHost}-${index}`,
        });
      });
      console.log("slides;", slides);

      return slides;
    },
  },

  created() {
    const name = store.getters["getCurrentHost"];
    this.currentHost = name;
    this.brandSubdomain = store.getters["getBrandSubdomain"];

    // 处理特殊轮播图（如xunxiang的图片组）
    if (this.currentHost === "xunxiang") {
      this.swiperImages = this.getImagesForSwiper("xunxiang");
    }
  },

  mounted() {
    console.log("current", this.swiper);
    new Swiper(".swiper-container", {
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 8000,
        disableOnInteraction: true,
      },
      pagination: ".swiper-pagination",
      nextButton: ".swiper-button-next",
      prevButton: ".swiper-button-prev",
      scrollbar: ".swiper-scrollbar",
    });
  },

  methods: {
    callback() {},

    // 获取assets静态资源
    getAssetsFile(name, folder, type = "png") {
      const context = require.context(
        "../assets/images",
        true,
        /\.(png|svg|jpg|jpeg)$/
      );
      const path = folder ? `./${folder}/${name}.${type}` : `./${name}.${type}`;
      const asset = context.keys().find((key) => key.includes(path));
      return asset ? context(asset) : null;
    },

    // 获取指定文件夹中的所有图片
    getImagesForSwiper(folder) {
      let context;
      switch (folder) {
        case "xunxiang":
          context = require.context(
            "../assets/swiper/xunxiang",
            true,
            /\.(png|jpg|jpeg|svg)$/
          );
          break;
        default:
          return [];
      }

      const images = context.keys().map((key) => context(key));
      return images;
    },

    // 获取背景图片样式
    getBackgroundStyle(backgroundImage) {
      if (!backgroundImage) return {};

      try {
        const imagePath = getBackgroundImagePath(backgroundImage);
        return {
          backgroundImage: `url(${imagePath})`,
          backgroundPosition: "center center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        };
      } catch (error) {
        console.warn(
          `Failed to load background image: ${backgroundImage}`,
          error
        );
        return {};
      }
    },

    // 获取产品图片路径
    getProductImagePath(imageName) {
      try {
        return getImagePath(imageName);
      } catch (error) {
        console.warn(`Failed to load product image: ${imageName}`, error);
        return "";
      }
    },

    // 获取品牌背景样式（完全动态，无需CSS类映射）
    getBrandBackgroundStyle(backgroundImage) {
      if (!backgroundImage) return {};

      try {
        const imagePath = getBackgroundImagePath(backgroundImage);
        return {
          backgroundImage: `url(${imagePath})`,
          backgroundPosition: "center center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          height: "360px",
        };
      } catch (error) {
        console.warn(
          `Failed to load brand background image: ${backgroundImage}`,
          error
        );
        return {
          height: "360px",
          backgroundColor: "#f5f5f5", // 降级处理
        };
      }
    },
  },
};
